import { render, staticRenderFns } from "./ProjectPurchaseOverview.vue?vue&type=template&id=7c56da82"
import script from "./ProjectPurchaseOverview.vue?vue&type=script&lang=ts"
export * from "./ProjectPurchaseOverview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports